import axios from "axios";
import Client from "../Client/Client.type";
import { PendencyValueDTO } from "../Client/PendencyValueDTO.type";

const API_URL = process.env.REACT_APP_MEI_PENDENCIAS_BACKEND;
export class APIService {
    static saveConsult(client: Partial<Client>) {
        

        const req = axios.post("/consult/create", client, {
            baseURL: API_URL,
        });

        return req;
    }


    static setPendencyValue(data: PendencyValueDTO ){
        const req = axios.post("/consult/set-pendency-value", data, {
            baseURL: API_URL,
        });

        return req;
    }
}

export default APIService;
